import { atom } from "jotai";

export const isLoading = atom(false);
